"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledIndicator = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var style_utils_1 = require("@nef/style-utils");
var Tooltip_1 = __importDefault(require("../Tooltip"));
var innerFunction = function (_a) {
    var color = _a.color, shade = _a.shade, size = _a.size, disabled = _a.disabled, props = __rest(_a, ["color", "shade", "size", "disabled"]);
    return react_1.default.createElement("div", __assign({}, props));
};
exports.StyledIndicator = styled_components_1.default(innerFunction)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  border-radius: 50%;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  width: 1rem;\n  height: 1rem;\n\n  ", ";\n\n  ", "\n\n  background: ", ";\n"], ["\n  border-radius: 50%;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  width: 1rem;\n  height: 1rem;\n\n  ",
    ";\n\n  ",
    "\n\n  background: ",
    ";\n"])), function (props) {
    return props.size === "sm" && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-width: 0.75px;\n      width: 0.5rem;\n      height: 0.5rem;\n    "], ["\n      border-width: 0.75px;\n      width: 0.5rem;\n      height: 0.5rem;\n    "])));
}, function (props) {
    return props.size === "lg" && styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      border-width: 1.25px;\n      width: 1.5rem;\n      height: 1.5rem;\n    "], ["\n      border-width: 1.25px;\n      width: 1.5rem;\n      height: 1.5rem;\n    "])));
}, function (props) {
    return props.disabled
        ? style_utils_1.colorSelector(props, "gray", 300)
        : style_utils_1.colorSelector(props, props.color, props.shade);
});
var Indicator = (function (_super) {
    __extends(Indicator, _super);
    function Indicator() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toggle = function () {
            _this.setState(function (prevState) { return ({ isOpen: !prevState.isOpen }); });
        };
        _this.state = {
            isOpen: false
        };
        return _this;
    }
    Indicator.prototype.render = function () {
        var _a = this.props, children = _a.children, className = _a.className, color = _a.color, disabled = _a.disabled, id = _a.id, shade = _a.shade, size = _a.size, tooltipColor = _a.tooltipColor, props = __rest(_a, ["children", "className", "color", "disabled", "id", "shade", "size", "tooltipColor"]);
        var isOpen = this.state.isOpen;
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.StyledIndicator, { id: id, color: color, shade: shade, size: size, disabled: disabled, className: className }),
            children && (react_1.default.createElement(Tooltip_1.default, __assign({}, props, { target: id, toggle: this.toggle, isOpen: isOpen, color: tooltipColor }), children))));
    };
    Indicator.defaultProps = {
        color: "success",
        placement: "right",
        shade: 500,
        size: "md"
    };
    return Indicator;
}(react_1.Component));
exports.default = Indicator;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=index.js.map